// Treatment-selection helpers for the lead-detail page. Pure (no Redux/DOM)
// so they unit-test cleanly and are reused by the multi-treatment rework.
import { toMillis } from './activeTreatment';

const mostRecentId = (treatmentsList) =>
    [...treatmentsList].sort((a, b) => toMillis(b?.updated_at) - toMillis(a?.updated_at))[0]?.id;

// Which treatment the Treatments tab should select.
// Default priority (refetch-safe): current → requested → most-recent.
// honourRequestedFirst (a NEW ?treatmentId=/selection arrived): requested → current → most-recent.
// Ids are String-coerced so a number/string mismatch never re-snaps to the wrong tab.
export const resolveTreatmentTabId = (treatmentsList, currentTab, requestedTreatmentId, { honourRequestedFirst = false } = {}) => {
    if (!Array.isArray(treatmentsList) || treatmentsList.length === 0) return '';
    const matchId = (id) =>
        (id === null || id === undefined || id === '')
            ? undefined
            : treatmentsList.find((t) => String(t?.id) === String(id))?.id;
    const current = matchId(currentTab);
    const requested = matchId(requestedTreatmentId);
    const ordered = honourRequestedFirst ? [requested, current] : [current, requested];
    return ordered.find((v) => v !== undefined) ?? mostRecentId(treatmentsList);
};

// Every treatment awaiting a Dentally fee payment, so each can surface its own
// banner — instead of only inspecting the active/first treatment.
